import styled from 'styled-components';

export default styled.div`
  font-size: 0.8rem;
  grid-area: title;
  padding: 0.5rem 0.5rem 0;
  font-weight: 500;
`;
